export const rules ={
  title: [
      { required: true, message: "请输入名称", trigger: "change" },
    ],
    type: [
      { required: true, message: "请选择类型", trigger: "change" },
    ],
    day_type: [
      { required: true, message: "请选择类型", trigger: "change" },
    ]
      
    }